export default "__VITE_ASSET__BpzYZJHD__"